import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Stack } from '../../component-stack';
import { getResponsiveStyles, useTokens } from '../../component-themes';
import { forwardRef } from 'react';
/**
 * Component to display the summary list in the `OrderSummaryFooter`.
 */
export const OrderSummaryFooterSummaryList = forwardRef(({ size, items, ...props }, ref) => {
    const tokens = useTokens();
    return (_jsx(Stack, { direction: "vertical", css: getResponsiveStyles(size, (size) => ({
            gap: tokens.styles[`orderSummary-summaryList-base-${size}-gap`],
        })), ...props, ref: ref, children: items({ size }) }));
});
OrderSummaryFooterSummaryList.displayName = 'OrderSummaryFooterSummaryList';
